import { Degree } from "../enums";

export const SENIORITY_BONUS_PERCENTAGE_PER_YEAR = 0.025;
export const COMMISION_BONUS_PERCENTAGE_PER_SEMESTER = 0.05;
export const MAX_LEGAL_WEEKLY_HOURS = 48;
export const DEGREE_BONUS = {
  [Degree.HighSchool]: 0,
  [Degree.UniversityStudent]: 0,
  [Degree.BachelorComplete]: 0,
  [Degree.Graduated]: 300,
  [Degree.Masters]: 600,
  [Degree.Doctorate]: 900,
  [Degree.Other]: 0,
};

export const VACATION_BONUS_PERCENTAGE = 0.25; // *
export const SUNDAY_BONUS_PERCENTAGE = 0.25; // *
export const MAX_WORK_WEEK_LIMIT = 48;
export const MAX_DOUBLE_PLAY_WORK_WEEK_LIMIT = 57; // *
export const JUSTIFIED_ABSENCES_PERCENTAGE = 0.6; // *
export const HOLIDAY_OR_REST_EXTRA_PAY_PERCENTAGE = 2;
export const DAILY_MEAL_COMPENSATION = 50; // *
export const ANNUAL_RAISE_PERCENT = 0.025;
export const WORKING_DAYS_IN_A_WEEK = 6;
export const AVERAGE_WORK_DAYS_PER_MONTH =
  (365 / 12 / 7) * WORKING_DAYS_IN_A_WEEK;
export const COMMISSION_SENIORITY_BONUS_PER_SEMESTER = 0.05;
export const AVERAGE_WORK_HOURS_PER_MONTH =
  AVERAGE_WORK_DAYS_PER_MONTH * (MAX_WORK_WEEK_LIMIT / WORKING_DAYS_IN_A_WEEK);
